import { t } from "@lingui/core/macro";
import { CloudAlert, OctagonMinus } from "lucide-react";
import { Button } from "@/components/ui/button.tsx";
import { cn } from "@/lib/utils.ts";
import { PageCenter } from "@/components/PageCenter.tsx";
import type { HTTPError } from "ky";
import { Trans } from "@lingui/react/macro";

interface Props {
  message: string;
  error?: HTTPError;
  className?: string;
}

export function FetchingError({ error, message, className }: Props) {
  const isAuthForbiddenError = error?.response?.status === 403;

  return (
    <PageCenter>
      <div className={cn("flex flex-col py-12 px-28 items-center justify-center gap-8", className)}>
        {isAuthForbiddenError ? (
          <OctagonMinus className={"text-destructive"} size={50} />
        ) : (
          <CloudAlert className={"text-destructive"} size={50} />
        )}

        {isAuthForbiddenError ? (
          <p className={"text-center text-muted-foreground max-w-md"}>
            <Trans>
              You don’t have permission to access this data. If you believe this is a mistake, please contact our
              support team.
            </Trans>
          </p>
        ) : (
          <p className={"text-center text-muted-foreground"}>{message}</p>
        )}

        {!isAuthForbiddenError && (
          <Button
            type={"button"}
            className={"cursor-pointer"}
            variant={"secondary"}
            onClick={() => window.location.reload()}
          >{t`Reload page`}</Button>
        )}
      </div>
    </PageCenter>
  );
}
